export default {
  namespaced:true,
  state() {
    return {
      nameImageList: []
    }
  },
  mutations: {
    SET_NAME_IMAGE_LIST(state, list) {
      state.nameImageList = list
    }
  },
  actions: {
     setNameImageList({commit}, list) {
      commit('SET_NAME_IMAGE_LIST', list)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/store/contract.js